import React from 'react';
import ReactDOM from 'react-dom';
import { getHashSafeQueryString } from '@amtrav/jsr';
import axios from 'axios';
import AcceptInviteApp from './AcceptInviteApp';

/*
 *Join Meeting a.k.a. Gather - Book Travel:
 *This is the first step of the join-meeting a.k.a. book-travel page
 *It will check if email is provided in the URL and if so, it'll forward to the accept-invite page which is it's own app
 *Otherwise, it will load the AcceptInviteForm in this app to collect the email
 */

const getUrlParams = () => getHashSafeQueryString()?.params || {};
const { email, firstName, middleName, lastName } = getUrlParams();
const meetingGuid = window.location.pathname.split('/')[2];
const url = `/api/v1/Meetings/ShareLinks/${meetingGuid}`;

// Build query parameters for API call
const queryParams = new URLSearchParams();
if (email) queryParams.append('email', email);
if (firstName) queryParams.append('firstName', firstName);
if (middleName) queryParams.append('middleName', middleName);
if (lastName) queryParams.append('lastName', lastName);

const requestUrl = queryParams.toString() ? `${url}?${queryParams.toString()}` : url;
axios
  .get(requestUrl)
  .then((response) => {
    const meetingInfo = response.data;
    // if we have a redirectLink, don't load app
    if (meetingInfo.redirectLink) {
      window.location.href = meetingInfo.redirectLink;
    } else {
      ReactDOM.render(<AcceptInviteApp meetingInfo={meetingInfo} />, document.getElementById('JoinMeetingApp'));
    }
  })
  .catch((response) => {
    console.log('Error: ', response);
    const errorMessage =
      response.response.data.code > 7000 && response.response.data.code < 9000
        ? response.response.data.message
        : 'An unexpected error occurred.';
    ReactDOM.render(<AcceptInviteApp meetingError={errorMessage} />, document.getElementById('JoinMeetingApp'));
  });
